import PropTypes from 'prop-types';

export const GIFTBIT_REWARDS__FETCH = 'GIFTBIT_REWARDS__FETCH';

export const GIFTBIT_REWARDS__SHAPE_ITEM = PropTypes.shape({
  available: PropTypes.bool,
  elementId: PropTypes.string,
  id: PropTypes.string,
  priceInCents: PropTypes.number,
  state: PropTypes.string,
  marketplaceGift: PropTypes.shape({
    currencyisocode: PropTypes.string,
    description: PropTypes.string,
    giftbitId: PropTypes.string,
    id: PropTypes.string,
    imageUrl: PropTypes.string,
    maxPriceInCents: PropTypes.number,
    minPriceInCents: PropTypes.number,
    name: PropTypes.string,
    redemptionInstructions: PropTypes.string,
    regionIds: PropTypes.arrayOf(PropTypes.number),
    tax: PropTypes.string,
    termsAndConditions: PropTypes.string,
  }),
});
export const GIFTBIT_REWARDS__SHAPE_ARRAY = PropTypes.arrayOf(GIFTBIT_REWARDS__SHAPE_ITEM);
